"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "name", "id", "ariaLabel", "children", "level", "type", "onClick", "outline", "block", "transparent", "secondary", "rounded", "muted"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var className = _ref.className,
      name = _ref.name,
      id = _ref.id,
      ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      level = _ref.level,
      type = _ref.type,
      onClick = _ref.onClick,
      outline = _ref.outline,
      block = _ref.block,
      transparent = _ref.transparent,
      secondary = _ref.secondary,
      rounded = _ref.rounded,
      _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      rest = _objectWithoutProperties(_ref, _excluded);

  var classes = (0, _react.useMemo)(function () {
    var base = muted ? 'gray-100' : secondary ? 'default-blue' : 'primary';
    var hoverBgColor = muted ? 'gray-200' : secondary ? 'blue-700' : 'yellow-700';
    var textColor = muted ? 'gray-500' : 'white';
    return (0, _classnames.default)('focus:outline-none focus:shadow-base text-base', "py-3 px-6 font-bold tracking-wide cursor border-2 border-".concat(base), outline && "bg-white text-".concat(base, " hover:text-white hover:bg-").concat(base), transparent && "text-white bg-transparent hover:bg-".concat(base), !outline && !transparent && "text-".concat(textColor, " bg-").concat(base, " hover:bg-").concat(hoverBgColor), rounded && 'rounded', block && 'w-full', className);
  }, [secondary, outline, transparent, rounded, muted, block, className]);
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    id: id,
    name: name // eslint-disable-next-line react/button-has-type
    ,
    type: type,
    className: classes,
    "aria-label": ariaLabel,
    onClick: onClick
  }, rest), children);
};

Button.propTypes = {
  name: _propTypes.default.string,
  id: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  children: _propTypes.default.any,
  onClick: _propTypes.default.func,
  type: _propTypes.default.string,
  level: _propTypes.default.string,
  className: _propTypes.default.string,
  outline: _propTypes.default.bool,
  block: _propTypes.default.bool,
  transparent: _propTypes.default.bool,
  secondary: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  muted: _propTypes.default.bool
};
Button.defaultProps = {
  name: 'button',
  id: undefined,
  ariaLabel: 'button',
  type: 'button',
  level: 'primary',
  className: '',
  outline: false,
  block: false,
  transparent: false
};
var _default = Button;
exports.default = _default;